import List from "list.js";
document.addEventListener("turbo:load", () => {
  $(document).ready(function () {
    const options = {
      valueNames: ["name"],
    };

    const userList = new List("optional_list", options);
    const extraList = new List("extra_list", options);
    // console.log(userList)

    $("#save_vehicle").mouseover(() => {
      $("#search_optionals").val("");
      userList.search();
    });
  });
});
